import React, { useContext } from "react";
import { GameContext, UserContext } from "../../App";

const LevelInfo = ({ level }) => {
    const gameProperties = useContext(GameContext)
    const currentUserData = useContext(UserContext);

	return (
		<div style={{display: "flex", flexDirection: "column", gap: "0px"}}>
			<h6 className="card-subtitle mb-2">
				<b>
					<span className={`game__${level?.game}`}>
						{
							gameProperties?.find(
								(game) => game?.internalID === level?.game,
							)?.name
						}
					</span>
				</b>
			</h6>
			<h6 className="card-subtitle mb-2 ">
				Difficulty: {level?.difficulty}
			</h6>
			<h6 className="card-subtitle mb-2 ">
				Comments: {level?.commenters?.length}{" "}
				{!!level?.commenters?.includes(currentUserData?._id) && (
					<span className="yellow">&#x2713;</span>
				)}
			</h6>
			<h6 className="card-subtitle mb-2 ">
				Plays: {level?.plays}{" "}
				{!!level?.hasPlayed && <span className="yellow">&#x2713;</span>}
			</h6>
			<h6 className="card-subtitle mb-2 ">
				Rates: {level?.rates?.length}{" "}
				{!!level?.hasRated && <span className="yellow">&#x2713;</span>}
			</h6>
		</div>
	);
};

export default LevelInfo;
